import { Box } from '@mui/material';
import Pagination from 'components/controls/Pagination';
import isEmpty from 'lodash/isEmpty';
import { arrayOf, number, object, shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import connector from './connector';
import FormItem from './FormItem';
import FormsList from './FormsList';

const LINKS_PER_PAGE = 10;

const Forms = ({ actions, forms, total }) => {
  const [page, setPage] = useState(0);

  useEffect(() => {
    actions.media.forms(page + 1, LINKS_PER_PAGE);
  }, [page, actions.media]);

  const changePage = ({ selected }) => {
    setPage(selected);
  };

  if (isEmpty(forms)) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <FormsList>
        {forms.map(form => (
          <FormItem key={form._id} form={form}>
            {form.text}
          </FormItem>
        ))}
      </FormsList>
      <Pagination perPage={LINKS_PER_PAGE} total={total} page={page} onChange={changePage} />
    </Box>
  );
};

Forms.propTypes = {
  forms: arrayOf(
    shape({
      description: string,
      favicon: string,
      title: string,
      url: string.isRequired,
    }),
  ).isRequired,
  total: number.isRequired,
  actions: object.isRequired,
};
export default connector(Forms);
